<template>
  <footer class="footer-background">
    <p class="creator-text">Made with 
      <img src="../../static/img/loveIcon.svg" alt="love">
       by  
      <a href="https://twitter.com/drishitmitra">@drishitmitra</a>
    </p>
    <div class="key-links">
      <a class="link" href="/terms-of-service">{{ $t('message.termsOfService') }}</a>
      <a class="link" href="/privacyPolicy">{{ $t('message.privacyPolicyLink') }}</a>
      <a class="link" href="/cookiePolicy">{{ $t('message.cookiePolicyLink') }}</a>
      <a class="link" href="/contact">{{ $t('message.contactLink') }}</a>
    </div>
  </footer>
</template>

<script>
  import Vue from 'vue'
  import VueI18n from 'vue-i18n'

  const messages = {
    en: {
      message: {
        contactLink: 'Contact',
        termsOfService: 'Terms of Service',
        privacyPolicyLink: 'Privacy Policy',
        cookiePolicyLink: 'Cookie Policy'
      }
    },
    hi: {
      message: {
        contactLink: 'संपर्क करें',
        termsOfService: 'सेवा की शर्तें',
        privacyPolicyLink: 'गोपनीयता नीति',
        cookiePolicyLink: 'कूकी नीति'
      }
    }
  }

  Vue.use(VueI18n)

  const i18n = new VueI18n({
    locale: typeof (Storage) !== 'undefined' ? localStorage.getItem('userLang') ? localStorage.getItem('userLang') : 'en' : 'en',
    messages: messages
  })

  export default {
    i18n,
    props: {
      userLang: {
        type: String,
        default: 'en'
      }
    },
    watch: {
      userLang: function (newVal) {
        i18n.locale = newVal
      }
    }
  }
</script>

<style scoped>
  .footer-background {
    height: 120px;
    background-color: #212121;
  }

  .creator-text {
    color: #ffffff;
    text-align: center;
    padding: 20px;
    font-size: 18px;
  }

  .key-links {
    text-align: center;
    padding-bottom: 15px;
  }

  .link {
    margin-right: 5px;
  }
</style>




// WEBPACK FOOTER //
// src/components/Footer.vue